import React, { useEffect, useRef, useState } from "react";
import { AiOutlineArrowLeft, AiOutlineArrowRight } from "react-icons/ai";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import Service from "../components/Service";
import ServiceItem from "../components/ServiceItem";
import { apiURL } from "../api";

function Services(props) {
  const scrollServices = useRef();
  const params = useParams();
  const [services, setServices] = useState([]);
  const Navigate = useNavigate();

  const [city, setCity] = useState("");
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");

  useEffect(() => {
    if (params.category === "category") {
      setServices(props.services);
    } else {
      const filterItems = props.services.filter((item) => {
        return item.category === params.category;
      });
      setServices(filterItems);
    }
  }, [params.category, props.services]);

  const filterServices = (category) => {
    const filterItems = props.services.filter((item) => {
      if (category === "All Categories") {
        return item;
      } else {
        return item.category === category;
      }
    });
    setServices(filterItems);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const LoadPage = async () => {
      try {
        const res = await fetch(`${apiURL}/check`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
        });

        const data = await res.json();
        setCity(data.city);
        setName(data.name);
        setAddress(data.address);
        setName(data.name);
      } catch (error) {
        Navigate("/login");
      }
    };
    LoadPage();
  }, [Navigate]);

  return (
    <div>
      {/* banner */}
      <div className="flex md:flex-row flex-col-reverse md:justify-around items-center m-auto w-[85%]">
        <div className="flex flex-col pt-6 md:pt-0 pl-10 pr-10">
          <h3 className="md:text-6xl text-4xl pb-3 font-bold text-primary">
            Find a Perfect
          </h3>
          <h3 className="md:text-6xl text-4xl pb-3 font-bold text-primary">
            Mechanic
          </h3>
          <div className="mb-4 mt-4">
            <NavLink to="/packages">
              <button className="mr-4 bg-secondary md:text-base text-sm text-white md:p-4 p-3 rounded-lg border-none outline-none">
                Book Now
              </button>
            </NavLink>
            <NavLink to="/shop/category">
              {" "}
              <button className="border border-primary md:pt-4 md:pb-4 p-2 pl-10 pr-10 rounded-lg outline-none">
                Shop
              </button>
            </NavLink>
          </div>
        </div>
        <div className="md:w-auto w-full">
          <img src="/images/banner2.png" alt="mechanic" />
        </div>
      </div>

      {/* categories */}
      <div className="flex justify-center h-full pt-6 pb-20 items-center w-[90%] mx-auto">
        <button
          onClick={() => scrollServices.current.scrollBy(-295, 0)}
          className="bg-slate-300 rounded-full p-2"
        >
          <AiOutlineArrowLeft />
        </button>
        <div
          ref={scrollServices}
          className="overflow-hidden flex justify-start items-center h-24 scrollbar-hide whitespace-nowrap scroll-smooth"
        >
          {props.servicesItems.map((serviceItem) => {
            return (
              <div
                key={serviceItem.id}
                onClick={() => filterServices(serviceItem.title)}
              >
                <ServiceItem
                  serviceItem={serviceItem}
                  services={props.services}
                />
              </div>
            );
          })}
        </div>
        <button
          onClick={() => scrollServices.current.scrollBy(200, 0)}
          className="bg-slate-300 rounded-full p-2"
        >
          <AiOutlineArrowRight />
        </button>
      </div>
      {/* services */}
      <div className="mx-auto w-[90%] flex-wrap flex md:justify-center justify-center items-center">
        {services.map((service) => {
          return (
            <div key={service._id}>
              <Service
                service={service}
                city={city}
                name={name}
                address={address}
              />
              ;
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Services;
